import { useState, useEffect } from "react";
import { OverlayTrigger, Popover } from "react-bootstrap";
import { useNavigate, useSearchParams } from "react-router-dom";
import FppeTaskModal from "../utils/FppeTaskModal";
import LastActivityDisplay from "../utils/LastActivityDisplay";


const TaskListRow = ({row, showModal, reloadTaskLists}) => {
  const [show, setShow] = useState(showModal);

  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (showModal && searchParams.has('task'))
    {
      const newParams = new URLSearchParams(searchParams);
      newParams.delete('task');
      navigate({ search: newParams.toString() }, { replace: true });
    }
  }, [showModal, searchParams, navigate]);
  
  const handleShow =  (cellId) => 
  {
    setShow(true);
  }

  const handleCancel = () => {
    setShow(false);
  }

  const handleSave = () => {
    setShow(false);
    reloadTaskLists();
  }

  const handleDelete = () => {
    setShow(false);
    reloadTaskLists();
  }

  return (
    <>         
      <tr {...row.getRowProps()} style={{cursor:"pointer"}}>
        {row.cells.map((cell) => {
          return (
            <OverlayTrigger
              key={cell.column.key}
              triggers="[hover,focus]"
              placement="bottom"
              overlay={<Popover><Popover.Body><LastActivityDisplay task={row.original.task}></LastActivityDisplay></Popover.Body></Popover>}
            >
              <td onClick={(e) => handleShow(cell.column.key)} className={(cell.column.key === "content" || cell.column.key === "created" || cell.column.key === "createdBy" || cell.column.key === "toNumber") && row.id.indexOf(".") > 0 ? "table-secondary" : ""} {...cell.getCellProps()}>
                {cell.render("Cell")}
              </td>
              </OverlayTrigger>
          );
        })}
      </tr>
      <FppeTaskModal key={row.original.task.id} show={show} onCancel={handleCancel} onSave={handleSave} onDelete={handleDelete} id={row.original.task.id} category={row.original.task.category.value} 
      providerId={row.original.task.providerIsDeleted ? 0 : row.original.task.providerId} facilityId={row.original.task.facilityId} description={row.original.task.description} status={row.original.task.status} 
      deadline={row.original.task.deadline} patientCount={row.original.task.patientCount}
      providerFormsComplete={row.original.task.providerFormsComplete} reviewerFormsComplete={row.original.task.reviewerFormsComplete} reviewerFirstName={row.original.task.reviewerFirstName} reviewerLastName={row.original.task.reviewerLastName} reviewerEmail={row.original.task.reviewerEmail} reviewerCredentials={row.original.task.reviewerCredentials} eSignatureTemplateId={row.original.task.eSignatureTemplateId}
      activeProviderUrl={row.original.task.activeProviderUrl} activeReviewerUrl={row.original.task.activeReviewerUrl} archived={row.original.task.archived} activityList={row.original.task.activity}/>
    </>
    )
}

export default TaskListRow;